<template>
	<div class="bg-white px-3 index" >
		<div class="add_tits" ref="titles">
		</div>
		<div class="ibox-content" :style="{height:height}">
			<el-form :model="addzx_count" :rules="rule" ref="addzx_count" label-width="150px"
				class="demo-ruleForm forms-lines">
				<el-form-item label="默认次数" prop='mr_count'>
					<el-input v-model="addzx_count.mr_count" size="small" style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="有效天数" prop='day_count'>
					<el-input v-model="addzx_count.day_count" size="small" style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="赠送次数" prop='zx_count'>
					<el-input v-model="addzx_count.zx_count" size="small" style="width:200px"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" @click="onSubmit('addzx_count')">提交</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex'
	import comment from '@/components/header/comment.vue';
	export default {
		components: {
			comment
		},
		data() {
			return {
				loading: false,
				height: null,
				eid: '0',
				subloading: false,
				addzx_count: {
					zx_count: '',
					day_count: '',
					mr_count: '',
				},
				rule: {
					zx_count: [{
						required: true,
						message: '请填写名称',
						trigger: 'blur'
					}],
					day_count: [{
						required: true,
						message: '请填写多少天内有效',
						trigger: 'blur'
					}],
					mr_count: [{
						required: true,
						message: '请填写默认次数',
						trigger: 'blur'
					}],
				},
			};
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		mounted() {
			let that = this
			that.getHeight()
			that.begin()
		},
		methods: {
			getHeight() {
				let that = this
				that.height = window.innerHeight - 180 + 'px'
				window.onresize = () => {
					that.height = window.innerHeight - 180 + 'px'
				}
			},
			begin() {
				let that = this
				that.search()
			},
			search() {
				let that = this
				that.loading = true
				axios.post("/admin/pc/DoctorInquiry/get_reply_config", {

					}, {
						token: true
					})
					.then(res => {
						this.addzx_count.zx_count = res.data.data.count
						this.addzx_count.day_count = res.data.data.time
						this.addzx_count.mr_count = res.data.data.default_count

					})
					.catch(error => {})
			},
			onSubmit(formName) {
				let that = this
				that.$refs[formName].validate((valid) => {
					if (valid) {
						that.subloading = true
						let urls = "/admin/pc/DoctorInquiry/reply_config"
						axios.post(urls, {
								default_count: that.addzx_count.mr_count,
								count: that.addzx_count.zx_count,
								time: that.addzx_count.day_count,
							}, {
								token: true
							})
							.then(response => {
								that.subloading = false
								if (response.data.code == '200') {
									that.search()
									this.$message({
										message: '成功',
										type: 'success'
									});
								} else {
									that.$message.error(response.data.msg);
								}
							})
							.catch(error => {
								that.subloading = true
							})
					} else {
						return false;
					}
				});
			},
		},
	};
</script>
<style scoped lang='scss'>
 .index{
        border-radius: 6px;
        padding-bottom: 10px;
		padding-top: 30px;
    }
	.tablimg {
		margin: 2px 5px;
	}
</style>